<template>
  <b-card
    title="Günlük Tahmini Tüketim"
    class="border border-secondary"
  >
    <b-row class="ml-5">
      <b-col md="3">
        <span>Abone</span>
        <div>
          <b-form-select
            v-model="selected"
            :options="options"
            :state="selected === null ? false : true"
          />

        </div>
      </b-col>
      <b-col md="3">
        <span>Sayaç</span>
        <div>
          <b-form-select
            v-model="selected"
            :options="options"
            :state="selected === null ? false : true"
          />

        </div>
      </b-col>

      <b-col md="6">
        <div class="mt-0">
          <span>Hesaplama Türü</span>
          <b-form-radio-group
            v-model="value"
            :options="options"
            :state="state"
            class="demo-inline-spacing"
            name="radio-validation"
          />
        </div>

      </b-col>
      <br>

    </b-row>
    <br>
    <div class="d-flex justify-content-left mr-1">

      <b-button-group
        class="kaydir"
        block
      >

        <b-button variant="warning">
          <feather-icon
            icon="SearchIcon"
          />

          Listele
        </b-button>
        <b-button variant="danger">
          <feather-icon
            icon="ArrowUpRightIcon"
          />

          Tüketim Girişi
        </b-button>
        <b-button variant="info">
          <feather-icon
            icon="ArrowRightIcon"
          />
          Sayaç Tüketim Girişi
        </b-button>
      </b-button-group>

    </div>
    <br>
    <hr>
    <b-row>
      <b-col md="6">
        <h3 class="border-bottom-0">
          Tahmini Tüketim</h3>
      </b-col>
      <b-col md="6">
        <h3>Gerçekleşen Tüketim</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-table
          class="renk1"
          responsive="sm"
          :items="items"
        />
        <br>
        <br>
        <div class="d-flex justify-content-center">
          <b-pagination
            v-model="currentPage"
            hide-goto-end-buttons
            :total-rows="rows"
          />
        </div>
      </b-col>

      <b-col md="6">
        <b-table
          class="renk1"
          responsive="sm"
          :items="items2"
        />
        <br>
        <br>
        <div class="d-flex justify-content-center">
          <b-pagination
            v-model="currentPage"
            hide-goto-end-buttons
            :total-rows="rows"
          />
        </div>
      </b-col>
    </b-row>

  </b-card>
</template>

<script>
import {
  BTable, BCard, BFormSelect, BFormRadioGroup, BCol, BRow, BButtonGroup, BButton, BPagination,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BCard,
    BFormSelect,
    BCol,
    BRow,
    BButtonGroup,
    BButton,
    BFormRadioGroup,
    BPagination,

  },
  data() {
    return {
      sdsd: 1,
      perPage: 1,
      rows: 100,
      items: [
        {
          tuketim_ayi: -1, T1: '', T2: '', T3: '', Toplam: '',
        },

      ],
      items2: [
        {
          tuketim_ayi: -1, T1: '', T2: '', T3: '', Toplam: '',
        },

      ],
      options: [
        { text: 'kWh', value: 'first' },
        { text: 'mWh', value: 'second' },
        { text: 'Tümü', value: 'five' },
      ],
    }
  },
}
</script>
<style>
.kaydir{
  float: left;
}
.renk1{
  background-color:bisque;
}
</style>
